"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var console_1 = require("./console");
var dom_1 = require("./dom");
var fetch_1 = require("./fetch");
var history_1 = require("./history");
var xhr_1 = require("./xhr");
function noEmpty(obj) {
    return !obj || (0, utils_1.isEmpty)(obj) ? undefined : obj;
}
var Breadcrumbs = /** @class */ (function () {
    function Breadcrumbs() {
        var _this = this;
        this.LIST_LIMIT = 50;
        this.breadcrumbs = [];
        (0, console_1.addConsoleInstrumentationHandler)(function (data) {
            _this.add({
                type: 'default',
                category: data.level,
                message: data.args.join(', '),
            });
        });
        (0, dom_1.addClickKeypressInstrumentationHandler)(function (data) {
            var target = (data.event.target || {});
            _this.add({
                type: 'default',
                category: data.name,
                // message: JSON.stringify(data),
                data: {
                    target: {
                        id: target === null || target === void 0 ? void 0 : target.id,
                        className: target === null || target === void 0 ? void 0 : target.className,
                        tagName: target === null || target === void 0 ? void 0 : target.tagName,
                    },
                },
            });
        });
        (0, fetch_1.addFetchInstrumentationHandler)(function (data) {
            var _a, _b, _c;
            var response_header = {};
            (_a = data.response) === null || _a === void 0 ? void 0 : _a.headers.forEach(function (val, key) {
                response_header[key] = val;
            });
            _this.add({
                type: 'http',
                category: 'fetch',
                data: {
                    headers: noEmpty((_b = data.args[1]) === null || _b === void 0 ? void 0 : _b.headers),
                    response_header: noEmpty(response_header),
                    method: data.fetchData.method,
                    url: data.fetchData.url,
                    time_span: data.startTimestamp && data.endTimestamp
                        ? data.endTimestamp - data.startTimestamp
                        : null,
                    status_code: (_c = data.response) === null || _c === void 0 ? void 0 : _c.status,
                },
            });
        });
        (0, xhr_1.addXhrInstrumentationHandler)(function (data) {
            var _a, _b, _c, _d, _e, _f;
            // get response headers
            var headers = (_b = (_a = data.xhr).getAllResponseHeaders) === null || _b === void 0 ? void 0 : _b.call(_a);
            var headersObj = {};
            if (headers) {
                var headerArray = headers.trim().split(/[\r\n]+/);
                headerArray.forEach(function (line) {
                    var parts = line.split(': ');
                    var header = parts.shift();
                    var value = parts.join(': ');
                    headersObj[header] = value;
                });
            }
            _this.add({
                type: 'http',
                category: 'xhr',
                data: {
                    headers: noEmpty((_c = data.xhr.__apms_xhr__) === null || _c === void 0 ? void 0 : _c.request_headers),
                    response_header: noEmpty(headersObj),
                    method: (_d = data.xhr.__apms_xhr__) === null || _d === void 0 ? void 0 : _d.method,
                    url: (_e = data.xhr.__apms_xhr__) === null || _e === void 0 ? void 0 : _e.url,
                    time_span: data.startTimestamp && data.endTimestamp
                        ? data.endTimestamp - data.startTimestamp
                        : null,
                    status_code: (_f = data.xhr.__apms_xhr__) === null || _f === void 0 ? void 0 : _f.status_code,
                },
            });
        });
        (0, history_1.addHistoryInstrumentationHandler)(function (data) {
            _this.add({
                type: 'navigation',
                category: 'navigation',
                data: {
                    from: data.from,
                    to: data.to,
                },
            });
        });
    }
    Breadcrumbs.prototype.get = function () {
        return __spreadArray([], this.breadcrumbs, true);
    };
    Breadcrumbs.prototype.add = function (breadcrumb) {
        var bread = {
            type: breadcrumb.type || 'default',
            trace_id: (0, utils_1.uuidv4)(),
            category: breadcrumb.category,
            message: breadcrumb.message,
            data: breadcrumb.data,
            timestamp: +Date.now(),
        };
        this.breadcrumbs.push(bread);
        if (this.breadcrumbs.length > this.LIST_LIMIT) {
            this.breadcrumbs = this.breadcrumbs.slice(-this.LIST_LIMIT);
        }
    };
    Breadcrumbs.prototype.clear = function () {
        this.breadcrumbs = [];
    };
    return Breadcrumbs;
}());
exports.default = Breadcrumbs;
